'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoPermission = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(NoPermission, _Component);

  function NoPermission(props) {
    (0, _classCallCheck3.default)(this, NoPermission);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = require('./NoPermission.scss');
    return _this;
  }

  NoPermission.prototype.render = function render() {
    return _react2.default.createElement(
      'div',
      { className: this.styles.nopermission_container },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement('i', { className: 'fa fa-info-circle' })
        ),
        'You don\'t have permission to access this page. Please contact the administrator!'
      )
    );
  };

  return NoPermission;
}(_react.Component), _class.propTypes = {}, _temp);
exports.default = NoPermission;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/NoPermission/NoPermission.js
// module id = 2306
// module chunks = 0